import Swiper from "swiper";
import Masonry from 'masonry-layout';
import {show as showLoader, hide as hideLoader} from './component_loader';

// define breakpoint
const breakpoint = window.matchMedia( '(max-width:688px)' );

// get all swiper/grid containers/wrappers
let all_container = new Array();
let all_wrapper = new Array();

// per wrapper, endless items
let all_items = new Array();

// swiper and masonry objects
let all_swipers = new Array();
let all_masonry = new Array();

// content Loader
let componentLoader = document.getElementById("component-loader");

// check if swiper or grid should be displayed on pageload
function initSwiperGrid() {
	resetArrays();
	breakpointCheck();
}

function resetArrays() {
	//empty Arrays in case somethings left
	all_container = [];
	all_wrapper = [];
	all_items = [];

	all_container = document.getElementsByClassName("is-container");
	all_wrapper = document.getElementsByClassName("is-wrapper");

	for (let i = 0; i < all_wrapper.length; i++) {
		all_items.push( all_wrapper[i].getElementsByClassName("is-item") );
	}
}


// check breakpoints
function breakpointCheck() {
	if ( breakpoint.matches === false ) {		
		setStyle("masonry");
		return;
	}  

	else if ( breakpoint.matches === true ) {
		setStyle("swiper");
		return;
	}
}


// set view (masonry or swiper)
function setStyle(parameter) {
	console.log("Change View to: ",parameter); 
	
	// remove masonry classes
	if(parameter === "swiper") {
		destroyAllMasonry();
		classesToSwiper();
		addAllSwipers();
	}

	else if (parameter === "masonry") {
		destroyAllSwiper();
		classesToMasonry();
		addAllMansonry();
		updateMasonryDelay();
	}
}


// helper functions: add or remove classes
function classesToSwiper() {
	for (let i = 0; i < all_container.length; i++) {
		all_container[i].classList.add("swiper-container");
		all_wrapper[i].classList.add("swiper-wrapper");
		
		all_wrapper[i].classList.remove("gridview__wrapper");
		
		for (let j = 0; j < all_items[i].length; j++) {
			all_items[i][j].classList.add("swiper-slide");
			all_items[i][j].classList.remove("grid-item");
		}
	}
}

function classesToMasonry() {
	for (let i = 0; i < all_container.length; i++) {
		all_container[i].classList.remove("swiper-container");
		all_wrapper[i].classList.remove("swiper-wrapper");
		
		all_wrapper[i].classList.add("gridview__wrapper");
		
		for (let j = 0; j < all_items[i].length; j++) {
			all_items[i][j].classList.remove("swiper-slide");
			all_items[i][j].classList.add("grid-item");
		}
	}
}




// Swipers
function addAllSwipers() {
	for (let i = 0; i < all_container.length; i++) {
		
		all_swipers[i] = new Swiper(all_container[i], {
			loop: false,
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 10,
			autoHeight: true,
		
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				// when window width is >= 480px
				689: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				// when window width is >= 1024px
				992: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
				1313: {
					slidesPerView: 4,
					spaceBetween: 28,
				},
				// when window width is >= 1440px
				1599: {
					slidesPerView: 4,
					spaceBetween: 32,
				},
			},
		});
	}
	
}

function destroyAllSwiper() {
	all_swipers.forEach(element => {
		element.destroy( true, true );
	});

	all_swipers = [];
}


// Masonry
function addAllMansonry() {
	for (let i = 0; i < all_container.length; i++) {	
		all_masonry[i] = new Masonry( all_wrapper[i], {
			itemSelector: '.grid-item',
			percentPosition: true,
			transitionDuration: 0,
		});
	}
}

function destroyAllMasonry() {
	console.log("Destroy all Masonry");
	for (let i = 0; i < all_wrapper.length; i++) {
		if(all_masonry[i] !== undefined) {
			all_masonry[i].destroy();
		}
	}

	all_masonry = [];
}

function updateMasonryDelay() {
	// dirty helper function to reload masonry aufter the use of lifewire
	setTimeout(function(){
		for (let i = 0; i < all_masonry.length; i++) {
			all_masonry[i].layout();
		}
	},200);
}



// create callback for lifewire collection
function initResetter() {
	console.log("Init Resetter");

	Livewire.hook('message.sent', (message, component) => {
		showLoader();

		console.log("Jetze!");
	});

	Livewire.hook('message.processed', (message, component) => {
		console.log("Reset Styles");

		destroyAllSwiper();
		destroyAllMasonry();
		initSwiperGrid();
		
		// disable content-loader
		hideLoader();
	});
}



// run functions if the DOM is ready
function ready() {
	breakpoint.addEventListener("change", breakpointCheck);
	initSwiperGrid();
	initResetter();
}

if (document.readyState === "complete") {
	ready();
} else {
	document.addEventListener("DOMContentLoaded", ready);
}